import SectionHeading from '@/pages/home/components/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { backgroundCards } from '@/mocks/home';

export default function BackgroundSection() {
  return (
    <section id="background" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <SectionHeading
          index="03"
          kicker="CONTEXT & KNOW-HOW"
          title="背景资料：先把「行规」和「关系」补上"
          desc="很多争执其实是因为不了解行业怎么运转。补齐项目背景、人物关系和常见惯例，你会发现自己对这件事的判断会稳很多。"
        />

        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="h-56 w-full md:h-72 lg:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20a%20folded%20film%20script%2C%20clapperboard%20and%20dried%20flowers%20on%20a%20warm%20cream%20desk%2C%20soft%20natural%20window%20light%2C%20muted%20red%20and%20olive%20green%20accents%2C%20calm%20documentary%20mood%2C%20high%20detail&width=900&height=1000&seq=chigua-context-2026&orientation=portrait"
                  alt="影视项目背景资料 补课示意"
                  title="51.吃瓜 背景资料 - 影视行业惯例说明"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <p className="font-heading text-sm font-bold text-foreground-950">
                  背景先于立场
                </p>
                <p className="mt-2 font-body text-xs leading-relaxed text-foreground-600">
                  同一个信息，放在不同的行业背景下会得出完全不同的结论。这也是补课里最容易被跳过、却最值钱的一步。
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-7 lg:gap-5">
            {backgroundCards.map((card, i) => (
              <Reveal key={card.title} delay={i * 80}>
                <article className="h-full rounded-lg border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-secondary-300 md:p-6">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${card.icon} text-xl`} />
                  </span>
                  <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {card.title}
                  </h3>
                  <p className="mt-2 font-body text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {card.desc}
                  </p>
                  <ul className="mt-4 space-y-2 border-t border-background-200 pt-4">
                    {card.points.map((point) => (
                      <li
                        key={point}
                        className="flex items-start gap-2 font-body text-xs text-foreground-700 md:text-sm"
                      >
                        <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-secondary-400" />
                        {point}
                      </li>
                    ))}
                  </ul>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}